const ComponyOffer = ({ data }) => (
  <div className="grid md:grid-cols-2 justify-center gap-4 xl:px-7">
    {data.map((value) => (
      <div
        key={value.id}
        className="rounded-lg border border-solid border-gray-50/10 py-6 md:py-7 px-4 md:px-8 group"
      >
        <h3 className="text-white fw-normal mb-0 group-hover:text-primary-yellow md:text-2xl text-xl pb-4">
          <span>{value.title}</span>
        </h3>
        <p className="text-sm md:text-base text-white font-light">
          <span dangerouslySetInnerHTML={{ __html: value.description }}></span>
        </p>
      </div>
    ))}
  </div>
);

export default ComponyOffer;
